import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import RevokeRepository from '../Repositories/RevokeRepository'

class RevokeBloc {

    revokeChannel = new Subject();
    repository = new RevokeRepository()

    constructor() {
        this.revokeChannel.next({status: apiResponse.INITIAL})
    }

    fetchRevoke = async (query) => {
        try {
            this.revokeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRevoke(query).then((result) => {
                this.revokeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.revokeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

}

export default RevokeBloc